const mapping: Record<string, string> = {
  id: 'l=>l.Id',
  description: 'l=>l.Description',
}

export const mapSortConditionalContentsParam = (key: string) => mapping[key]
